<template>
  <component :is="component" v-if="component" :termsData="termsData"/>
</template>

<script>
export default {
  name: "TermsDetailLink",
  mixins: [],
  components: {},
  provide() {
    return {}
  },
  props: {
    detailLayout: {},
    termsData: {default: () => {return {}}},
  },
  data() {
    return {
      component: null,
    }
  },
  created() {
  },
  mounted() {
    this.writeLoader()
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.detailLayout) {
        return null
      }
      return () => import(`@/template/terms/detail/${this.detailLayout}`)
    },
  },
  methods: {
    writeLoader() {
      this.loader()
          .then(() => {
            this.component = () => this.loader()
          })
          .catch(() => {
            this.component = () => import('@/template/terms/detail/TermsDetailDefaultLayout')
          })
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>